export default __webpack_public_path__ + "static/bg5-3fbe0f19f455f2d706750c391c0c8440.jpg";